import script from "./MockPrinciple.vue?vue&type=script&setup=true&lang=js"
export * from "./MockPrinciple.vue?vue&type=script&setup=true&lang=js"

import "./MockPrinciple.vue?vue&type=style&index=0&id=46c22b44&lang=css"

const __exports__ = script;

export default __exports__